import { atom } from 'recoil';

export { classesAtom };

const classesAtom = atom({
    key: {
        name: 'classes'
    },
    default: []
});
